// extracted by mini-css-extract-plugin
module.exports = {"podcasts":"podcast_podcasts__p9f-L","podcastList":"podcast_podcastList__23N0t"};